export const getCookie = (name: string) => {
  let result = null;

  const cookieName = name + '=';
  const allcookies = document.cookie;

  const position = allcookies.indexOf(cookieName);
  if (position != -1) {
    const startIndex = position + cookieName.length;

    let endIndex = allcookies.indexOf(';', startIndex);
    if (endIndex == -1) {
      endIndex = allcookies.length;
    }

    result = decodeURIComponent(allcookies.substring(startIndex, endIndex));
  }

  return result;
};

export const setCookie = (name: string, value: string) => {
  let Cookeie = "";
  if( name == 'loginToken' ){
    Cookeie = 'loginToken=Bearer%20' + value + ';path=/';
  }else{
    Cookeie = `${name}=${encodeURIComponent(value)}; path=/`;
  }
  // Cookeie += ';domain='+location.host;
  document.cookie = Cookeie;
};

export const removeCookie = (name: string) => {
  // document.cookie = `${name}=;path=/;domain=${location.host}max-age=0`;
  document.cookie = `${name}=;path=/;max-age=0`;
};
